import React from "react";

export default function SectionCard({ id, title, subtitle, icon, actions, children }) {
  return (
    <section
      id={id}
      className="rounded-2xl ring-1 ring-slate-200/70 bg-white/90 shadow-sm p-6 mb-6"
    >
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="text-orange-500">{icon}</span>
            <h2 className="text-xl md:text-2xl font-semibold dark:text-gray-800">{title}</h2>
          </div>
          {subtitle ? (
            <p className="text-slate-700 mt-2 leading-relaxed">{subtitle}</p>
          ) : null}
        </div>
        {actions ? <div className="shrink-0">{actions}</div> : null}
      </div>
      <div className="mt-5">{children}</div>
    </section>
  );
}
